(() => {
  const popup = document.querySelector('[data-demasi-welcome]');
  if (!popup) return;
  const key = 'demasi.welcome.v1';
  const pendingKey = `${key}.pending`;
  let hasOpened = false;
  let ready = false;
  let lastFocus = null;
  let pending = 0;
  let stored = {};
  const day = 86400000;
  try { stored = JSON.parse(localStorage.getItem(key) || '{}'); } catch {}
  try { pending = Number(sessionStorage.getItem(pendingKey)); } catch {}
  const save = (days) => {
    try { localStorage.setItem(key, JSON.stringify({ until: Date.now() + days * day })); } catch {}
  };
  const pendingSubmission = pending > Date.now() - 10 * 60000;
  const success = pendingSubmission && Boolean(popup.querySelector('[data-welcome-success]'));
  const errors = pendingSubmission && Boolean(popup.querySelector('[data-welcome-errors]'));
  const inUse = () => Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"]')).some((element) => !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden') || document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
  const show = (force = false) => {
    if (hasOpened || (!force && (inUse() || document.visibilityState !== 'visible'))) return;
    hasOpened = true;
    lastFocus = document.activeElement;
    popup.hidden = false;
    document.removeEventListener('scroll', maybeShow, true);
    if (force) popup.querySelector('input[type="email"], button')?.focus({ preventScroll: true });
  };
  const dismiss = () => {
    popup.hidden = true;
    save(success ? 365 : 7);
    if (popup.contains(document.activeElement)) lastFocus?.focus({ preventScroll: true });
  };
  function maybeShow(event) {
    const target = event?.target instanceof Element ? event.target : document.scrollingElement;
    const scrollTop = Math.max(window.scrollY || 0, document.documentElement.scrollTop, document.body.scrollTop, target?.scrollTop || 0);
    const scrollable = Math.max(document.documentElement.scrollHeight - window.innerHeight, (target?.scrollHeight || 0) - (target?.clientHeight || 0));
    if (ready && scrollable > 0 && scrollTop >= Math.min(240, scrollable * .2)) show();
  }
  popup.querySelectorAll('[data-welcome-close]').forEach((button) => button.addEventListener('click', dismiss));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) dismiss();
  });
  popup.querySelector('form')?.addEventListener('submit', () => {
    try { sessionStorage.setItem(pendingKey, String(Date.now())); } catch {}
  });
  if (success || errors) {
    if (success) {
      save(365);
      try { sessionStorage.removeItem(pendingKey); } catch {}
    }
    show(true);
    return;
  }
  if (popup.dataset.subscribed === 'true' || Number(stored.until) > Date.now() || popup.querySelector('[data-welcome-success]')) return;
  document.addEventListener('scroll', maybeShow, { passive: true, capture: true });
  window.setTimeout(() => { ready = true; maybeShow(); }, 12000);
})();
